import { useEffect, useState } from "react";
import { Search, LogOut, Menu } from "lucide-react";
import "./topbar.css";

export default function Topbar({ onSearch, onLogout, toggleSidebar }) {
  const [query, setQuery] = useState("");

  /* =====================
     DEBOUNCED SEARCH
  ===================== */
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch?.(query.trim());
    }, 400);

    return () => clearTimeout(timer);
  }, [query, onSearch]);

  return (
    <header className="topbar">
      {/* LEFT SECTION */}
      <div className="topbar-left">
        {toggleSidebar && (
          <button className="icon-btn" onClick={toggleSidebar}>
            <Menu size={18} />
          </button>
        )}

        <div className="title-group">
          <h1 className="topbar-title">Admin Panel</h1>
          <span className="topbar-subtitle">
            campus.metrouni.edu.bd
          </span>
        </div>
      </div>

      {/* SEARCH */}
      <div className="topbar-search">
        <Search size={16} className="search-icon" />
        <input
          type="text"
          placeholder="Search by ID, name, email, or mobile"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      {/* RIGHT ACTIONS */}
      <div className="topbar-actions">
        <button className="logout-btn" onClick={onLogout}>
          <LogOut size={16} />
          Logout
        </button>
      </div>
    </header>
  );
}
